module.exports = __webpack_public_path__ + "img/logo_daishiyong@2x.9a931b0f.png";